import React, { useEffect, useRef } from 'react';
import './style.scss';
import { getContent, handleClickHistoryButton } from '@/utils/tools';
import { INPUT_TYPE, TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';
import { TrackerProps, ChatbotUIBasicProps } from '@/types/common';
import { InitStoreType } from '@/types/store/init';
import { handleRequest } from '@/utils';
import { dispatchTrack } from '@/utils/tracking';
import { addObserver, removeObserver } from '@/utils/intersectionObserver';
import { initStore } from '@/stores';
import { inject, observer } from 'mobx-react';
import { getChildInject } from '@/utils/instantLoaded/tools';

interface Props extends TrackerProps {
  content: string;
  isHistory: boolean;
  initStore: InitStoreType;
  dialogueId: string;
  isTFE?: boolean;
  threadId?: string;
  threadNodeId?: string;
  threadIdV2?: string;
  roundId?: string;
  nodePointId: string;
  historyDialogueId?: string;
  historySessionId?: string;
  sessionId: string;
  button?: {
    node_id: string;
    text_key: string;
    text_value: string;
    button_id: string;
    button_type: string;
    ext_key_value: string;
    action?: {
      task_bot_action?: any;
      is_bypass?: boolean;
    };
  };
  customCallback?: ChatbotUIBasicProps['customCallback'];
}

const PREFIX = 'order_tip-container';

const OrderTipMsg = (props: Props) => {
  const {
    initStore: { sessionId },
    isHistory,
    nodePointId,
    dialogueId,
    content,
    button,
    historySessionId,
    historyDialogueId,
  } = props;
  const myRef = useRef<HTMLDivElement | null>(null);

  const trackingname = TRACKING_TYPE.ORDER_TIP_MSG_BUTTON;
  const trackingdata = {
    chat_session_id: isHistory ? historySessionId : sessionId,
    chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
    node_point_id: nodePointId,
  };

  useEffect(() => {
    addObserver(myRef.current);

    return () => {
      removeObserver(myRef.current);
    };
  }, []);

  const handleClick = () => {
    if (isHistory) {
      handleClickHistoryButton();
      return;
    }

    requestMessage();

    dispatchTrack({
      operation: TRACKING_OPERATION.CLICK,
      section: TRACKING_SECTION.orderTipMsgButton,
      target: TRACKING_TARGET.orderTipMsgButton,
      data: {
        chat_session_id: initStore?.sessionId,
        chat_dialogue_id: dialogueId,
        node_point_id: nodePointId,
      },
    });
  };

  const requestMessage = () => {
    const { dialogueId, button, threadId, threadNodeId, threadIdV2, roundId, customCallback = {} } = props;

    handleRequest('postMessage', {
      session_id: initStore?.sessionId,
      dialogue_id: dialogueId,
      input_type: INPUT_TYPE.BUTTON,
      message_text: getContent(button),
      thread_id: threadId,
      thread_node_id: threadNodeId,
      thread_id_v2: threadIdV2,
      round_id: roundId,
      is_bypass: button?.action?.is_bypass,
      message_extra: {
        node_id: button?.node_id,
        ext_key_value: button?.ext_key_value,
        task_bot_action: button?.action?.task_bot_action,
        params: { order_id: 0 },
      },
      ...customCallback,
    });
  };

  return (
    <div
      ref={myRef}
      className={PREFIX}
      data-trackingname={trackingname}
      data-trackingdata={JSON.stringify(trackingdata)}
    >
      {content}
      <span
        className="button"
        onClick={() => {
          handleClick();
        }}
      >
        {getContent(button)}
      </span>
    </div>
  );
};

export default inject(getChildInject('initStore'))(observer(OrderTipMsg));
